import { gql } from '@apollo/client';

export const GET_DOCUMENT_TYPES_LIST = gql`
  query ChatbotDocumentTypes($params: FindDocumentTypeListInput!) {
    chatbotDocumentTypes(params: $params) {
      success
      message
      errors
      data {
        documentTypes {
          id
          code
          name
          description
          chunkSize
          chunkOverlap
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_DOCUMENT_TYPE = gql`
  query ChatbotDocumentType($params: FindDocumentTypeInput!) {
    chatbotDocumentType(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        description
        chunkSize
        chunkOverlap
        createdAt
        createdBy
      }
    }
  }
`;
